import { types } from 'mobx-state-tree'
import { DOMAIN_ACTION } from '@/constants'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
const axios = axiosPrivateHelper()

type SupplierDashboardType = {
  id: number
}

export const supplierDashboardModel = types
  .model('DashboardModel')
  .props({
    id: types.number,
  })
  .actions((self: SupplierDashboardType) => {
    const setProfile = (value: SupplierDashboardType) => {
      self.id = value.id
    }

    const updateAccountDetails = async (payload: any, userId: number) => {
      const res = await axios.put(
        `${DOMAIN_ACTION.API.USERS.UPDATE_USER(userId)}`,
        payload
      )

      return res
    }

    return {
      setProfile,
      updateAccountDetails,
    }
  })
